<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-file-invoice"></i> Challans</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'challans'}">Challans</router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                        <template v-if="component === 'marketplaceviewchallan' || component ==='marketplaceeditchallan'">
                            <router-link :to="{name: 'marketplacechallans'}" class="btn btn-secondary waves-effect waves-light text-white">
                                <i class="fas fa-arrow-left"></i>&nbsp; Back
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "Layout",
    data() {
        return {
            component: null
        }
    },
    watch: {
        $route(to, from) {
            this.component = to.name;
        }
    },
    created() {
        this.component = this.$route.name;
    }
}
</script>

<style scoped>

</style>
